import { basePathRewrite } from '@components/common';
import { errorEvent } from '@components/common/event-tracker';
import { JobLinks, socialLinks } from '@components/wlb/constant';
import {
  ErrorPage,
  errorTitles,
  extractCategoryFromUrl,
  extractJobTitleFromURL,
} from '@license-admin/boldjobs';
import errorPageProps from '@utils/errorPageProps';
import { logErrorServer } from 'API/ApiHelpers';
import { NextPage, NextPageContext } from 'next';
import Head from 'next/head';
import { useEffect, useMemo, useState } from 'react';

interface ErrorProps {
  statusCode: number;
  fromPage?: string;
  themeType?: string;
}

const ErrorPages: NextPage<ErrorProps> = ({
  statusCode,
  fromPage,
  themeType,
}) => {
  const [isSearchPage, setIsSearchPage] = useState<boolean>(false);
  const [IsCategoryPage, setIsCategoryPage] = useState<any>(null);
  const [jobTitle, setJobTitle] = useState<string>('');
  const statusCodes = statusCode ?? 404;
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const currentUrl = window.location.pathname + window.location.search;
      setIsSearchPage(currentUrl.includes('/search'));

      const isCategoryPages = extractCategoryFromUrl(window.location.href);
      setIsCategoryPage(isCategoryPages);

      // Extract job title from URL if it's a job details page
      const extractedTitle = extractJobTitleFromURL(currentUrl);
      setJobTitle(extractedTitle);
    }
    let pathName =
      typeof window === 'object' && window?.location?.href
        ? window.location.href
        : '';
    errorEvent(statusCodes, fromPage || pathName);
  }, []);

  // Get error title based on status code
  const contentTitle = useMemo(() => {
    return (
      errorTitles[statusCodes as keyof typeof errorTitles] || {
        ...errorTitles.default,
        heading: errorTitles.default.heading.replace(
          '{0}',
          statusCodes.toString()
        ),
      }
    );
  }, [statusCodes]);
  const IsCategoriesPage = IsCategoryPage?.isCategory;
  const errorPageProp = errorPageProps({
    statusCode: statusCodes,
    jobLinks: JobLinks,
    socialLinks: socialLinks,
    themeType: themeType || 'graphite',
    basePathRewrite: basePathRewrite,
    isCategoriesPage: IsCategoriesPage,
    jobTitle: jobTitle,
    isSearchPage: isSearchPage,
  });
  return (
    <>
      <Head>
        <title>{contentTitle.heading}</title>
      </Head>
      <ErrorPage {...errorPageProp} />
    </>
  );
};

ErrorPages.getInitialProps = ({
  req,
  res,
  err,
}: NextPageContext): ErrorProps => {
  const statusCode = res
    ? res.statusCode
    : err && err.statusCode
    ? err.statusCode
    : 404;
  if (err) {
    let errorMessage = 'RMC RMC_JOBS Server error: ' + err.message;
    if ('page' in err) {
      errorMessage += ' error.page: ' + err.page;
    }
    let errorDescription = '';
    if (err.statusCode) {
      errorDescription += ' error.statusCode: ' + err.statusCode;
    }
    errorDescription += ' error.stack: ' + err.stack;
    let cookie = '';
    if (res && res.req && res.req.headers && res.req.headers.cookie) {
      cookie = res.req.headers.cookie;
    }
    logErrorServer(errorMessage, errorDescription, false, cookie);
  }
  return { statusCode, fromPage: req?.headers?.referer || '' };
};

export default ErrorPages;
